type PaddleUserLocationProps = {
  countryCode: string;
  postalCode: string;
  region: string;
};

class PaddleUserLocation {
  props: PaddleUserLocationProps;

  constructor(props: PaddleUserLocationProps) {
    this.props = props;
  }

  static fromJson = (json: any): PaddleUserLocation => {
    return new PaddleUserLocation({
      countryCode: json.country_code,
      postalCode: json.postal_code,
      region: json.region,
    });
  };
}

export { PaddleUserLocation };
